
(() => {
  const mediaBindings = new WeakMap();
  const keyboardBindings = new WeakSet();
  let updateScheduled = false;

  function addPlaybackStyles() {
    if (document.getElementById('lc-instafeed-accessibility-styles')) return;

    const style = document.createElement('style');
    style.id = 'lc-instafeed-accessibility-styles';

    style.textContent = `
      .instafeed-lightbox .instafeed-video-control {
        display: inline-flex !important;
        position: absolute !important;
        visibility: visible !important;
        opacity: 1 !important;
        align-items: center;
        justify-content: center;
        top: auto !important;
        bottom: 12px !important;
        left: 12px !important;
        right: auto !important;
        transform: none !important;
        width: 44px !important;
        height: 44px !important;
        min-height: 44px;
        padding: 0;
        box-sizing: border-box;
        border: 2px solid #fff;
        border-radius: 50%;
        background-color: #262626 !important;
        color: #fff;
        font: 16px/1.2 sans-serif;
        text-align: center;
        cursor: pointer;
        z-index: 10;
      }

      .instafeed-lightbox .instafeed-sound-button {
        position: absolute !important;
        background-color: #262626 !important;
      }

      .instafeed-lightbox .instafeed-video-control:focus-visible,
      .instafeed-lightbox .instafeed-sound-button:focus-visible,
      .instafeed-lightbox .instafeed-close-button:focus-visible,
      .instafeed-lightbox .instafeed-new-arrow:focus-visible {
        outline: 3px solid #fff !important;
        outline-offset: 3px;
        box-shadow: 0 0 0 6px #262626;
      }
    `;

    document.head.appendChild(style);
  }

  function supportSpaceKey(button) {
    if (button.matches('button, input') || keyboardBindings.has(button)) return;

    button.addEventListener('keydown', (event) => {
      if (event.code !== 'Space' && event.key !== ' ') return;

      event.preventDefault();
      event.stopPropagation();

      if (!event.repeat) button.click();
    });

    keyboardBindings.add(button);
  }

  function setAttributeIfChanged(element, name, value) {
    if (element.getAttribute(name) !== value) {
      element.setAttribute(name, value);
    }
  }

  function removeAttributeIfPresent(element, name) {
    if (element.hasAttribute(name)) {
      element.removeAttribute(name);
    }
  }

  function labelControl(button, label) {
    setAttributeIfChanged(button, 'aria-label', label);
    setAttributeIfChanged(button, 'data-tooltip', label);
  }

  function bindVideoControl(button, kind) {
    const video = document.getElementById(button.dataset.videoId);
    const existing = mediaBindings.get(button);

    if (existing && existing.video === video && existing.kind === kind) {
      existing.update();
      return;
    }

    if (existing) {
      existing.events.forEach((event) => {
        existing.video.removeEventListener(event, existing.update);
      });
      mediaBindings.delete(button);
    }

    if (!video || video.tagName !== 'VIDEO') {
      removeAttributeIfPresent(button, 'aria-controls');
      return;
    }

    const events = kind === 'play'
      ? ['play', 'pause', 'ended']
      : ['volumechange'];

    const update = () => {
      if (!button.isConnected) return;

      const label = kind === 'play'
        ? (video.paused ? 'Play Instagram video' : 'Pause Instagram video')
        : (video.muted ? 'Unmute Instagram video' : 'Mute Instagram video');

      labelControl(button, label);
      setAttributeIfChanged(button, 'aria-controls', video.id);
    };

    events.forEach((event) => video.addEventListener(event, update));

    mediaBindings.set(button, {
      video,
      kind,
      events,
      update
    });

    update();
  }

  function syncInstagramVideoControls() {
    document.querySelectorAll('.instafeed-video-control').forEach((button) => {
      bindVideoControl(button, 'play');
    });

    document.querySelectorAll('.instafeed-sound-button').forEach((button) => {
      bindVideoControl(button, 'sound');
    });
  }

  function updateInstafeedAccessibility() {
    document.querySelectorAll('.instafeed-new-arrow.prev').forEach((button) => {
      labelControl(button, 'Previous Instagram post');
    });

    document.querySelectorAll('.instafeed-new-arrow.next').forEach((button) => {
      labelControl(button, 'Next Instagram post');
    });

    document.querySelectorAll('.instafeed-close-button').forEach((button) => {
      labelControl(button, 'Close Instagram post');
    });

    // Use the visible Instagram handle as the link name.
    document.querySelectorAll('.instafeed-bottom-link-wrapper a').forEach((link) => {
      if (/^@[a-zA-Z0-9._]+$/.test(link.textContent.trim())) {
        removeAttributeIfPresent(link, 'aria-label');
      }
    });

    document.querySelectorAll('.instafeed-lightbox').forEach((lightbox) => {
      // The outer container includes all dialog controls.
      setAttributeIfChanged(lightbox, 'role', 'dialog');
      setAttributeIfChanged(lightbox, 'aria-modal', 'true');
      removeAttributeIfPresent(lightbox, 'aria-labelledby');
      setAttributeIfChanged(lightbox, 'aria-label', 'Instagram post details');

      // Avoid conflicting nested dialog semantics.
      lightbox.querySelectorAll('.lightbox-instagram').forEach((inner) => {
        ['role', 'aria-modal', 'aria-labelledby', 'aria-label'].forEach((name) => {
          removeAttributeIfPresent(inner, name);
        });
      });
    });

    // Enable Space activation for custom role=button controls.
    document.querySelectorAll(
      '.instafeed-lightbox [role="button"], #insta-feed [role="button"]'
    ).forEach(supportSpaceKey);

    syncInstagramVideoControls();
  }

  function scheduleUpdate() {
    if (updateScheduled) return;

    updateScheduled = true;

    window.requestAnimationFrame(() => {
      updateScheduled = false;
      updateInstafeedAccessibility();
    });
  }

  function initialize() {
    addPlaybackStyles();
    updateInstafeedAccessibility();

    document.addEventListener('instafeedAppLoaded', scheduleUpdate);

    const observer = new MutationObserver(scheduleUpdate);

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: [
        'aria-label',
        'aria-labelledby',
        'aria-modal',
        'role',
        'data-video-id'
      ]
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
